import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { selectCurrentToken, setCredentials } from "./authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useGuestLoginMutation } from "./authApiSlice";
import { useEffect, useState } from "react";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";

const IsUserLoggedIn = () => {
  const { roles } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector(selectCurrentToken);
  const [isLoginTriggered, setIsLoginTriggered] = useState(false);
  const [searchParams] = useSearchParams();
  const workbookId = searchParams.get("workbookid");
  const sheetId = searchParams.get("sheetid");

  localStorage.setItem("URLworkbookId", workbookId);
  localStorage.setItem("URLsheetId", sheetId);
  const URLworkbookId = localStorage.getItem("URLworkbookId");
  const URLsheetId = localStorage.getItem("URLsheetId");
  const [
    guestLogin,
    { data: guestUserData, isLoading, isError, isSuccess, error },
  ] = useGuestLoginMutation();

  useEffect(() => {
    //check if user is logged in
    if (roles.length > 0 && !roles.includes("Guest")) {
      //this means user is logged in and not a guest
      if (URLworkbookId && URLsheetId) {
        navigate(
          `/dashboard?workbookid=${URLworkbookId}&sheetid=${URLsheetId}`
        );
      } else {
        navigate("/home/dash");
      }
    } else if (roles.length > 0) {
      //user logged in and is a guest
      return <Outlet />;
    } else {
      //not logged in
      guestLogin();
    }
  }, []);

  if (isLoading) {
    return (
      <div>
        Logging in as guest user <LoadingIndicator />
      </div>
    );
  }
  if (isError) {
    console.log("Login Error:", error);
    return <div>Error logging in</div>;
  }
  if (isSuccess) {
    console.log("accessToken is set", guestUserData.accessToken);
    if (token === null) {
      dispatch(setCredentials({ accessToken: guestUserData.accessToken }));
    }
    return <Outlet />;
  }

  // useEffect(() => {
  //   if (!token && !isLoginTriggered) {
  //     setIsLoginTriggered(true);
  //     guestLogin();
  //   }
  // }, [token, isLoginTriggered, guestLogin]);

  // useEffect(() => {
  //   if (isSuccess && guestUserData?.accessToken) {
  //     dispatch(setCredentials({ accessToken: guestUserData.accessToken }));
  //   }
  // }, [isSuccess, guestUserData, dispatch]);

  // useEffect(() => {
  //   if (roles?.length > 0) {
  //     if (!roles.includes("Guest")) {
  //       navigate("/home/dash"); // Redirect non-guest users to home
  //     }
  //   }
  // }, [roles, navigate]);

  // if (isLoading) {
  //   return (
  //     <div>
  //       Logging in as guest user <LoadingIndicator />
  //     </div>
  //   );
  // }

  // if (isError) {
  //   console.error("Login Error:", error);
  //   return <div>Error logging in</div>;
  // }

  // if (isSuccess) {
  //   dispatch(setCredentials({ accessToken: guestUserData.accessToken }));

  //   return <Outlet />; // Allow guest users to access the outlet
  // }
};

export default IsUserLoggedIn;
